export type Auth0TokenSyncSentryTagsInput = {
    component: string;
    action: string;
};

export function auth0TokenSyncSentryTags({ component, action }: Auth0TokenSyncSentryTagsInput) {
    return {
        tags: {
            component,
            action,
            severity: 'LOW',
        },
    } as const;
}
